/**
 * Copyright (c) 2021 - Present. Blend Labs, Inc. All rights reserved
 * Blend Confidential - Restricted
 */
import { StyleSheet } from 'aphrodite';
import { TextInput, isEmptyValue } from '@blend/enterprise-components';
import { inputFormatters } from '@blend/shared-react';

import { WrappedInput } from 'blb-components/WrappedInput';
import { FinalFormInputConfig } from 'blb-ui-types/helpers';

const styles = StyleSheet.create({
  fieldWrapper: {
    ':not(:last-child)': {
      marginBottom: 24,
    },
  },
});

export const phoneNumber: FinalFormInputConfig<TextInput.Props, string> = {
  component: WrappedInput,
  containerStyles: [styles.fieldWrapper],
  customComponentProps: { type: 'phone' },
  inputComponent: TextInput,
  label: 'Mobile phone number ',
  labelSize: 'sm',
  name: 'phoneNumber',
  parse: inputFormatters.PHONE.normalize,
  validate: isEmptyValue('Please input a phone number'),
};
